import React from 'react';
import moment from 'moment';
import { DayOff } from 'src/components';
import { getDaysOffFilteredByReason } from 'src/utils/calendar';

import { dayOffColor, holidayColor } from '../../../../../constants/colors';
import { DaysOffMenuIcon, HolidaysMenuIcon } from '../../../../../Icons';
import {
  SectionBottomContainer,
  SectionContainer,
  SectionEmptyBlock,
  SectionHeader,
  SectionLabel,
  SectionWrapper,
} from '../common';

import { TimeListSection } from './components/TimeListSection';

interface DayOffSectionProps {
  daysOff?: Array<DayOff>;
  onClick?: (reasonKey: string) => void;
}

export function DayOffSection({
  daysOff,
  onClick,
}: DayOffSectionProps) {

  const daysOffFilteredByReason = getDaysOffFilteredByReason(daysOff);

  const renderSections = () => {
    return Object.entries(daysOffFilteredByReason).map(([reasonKey, value]: any) => {
      const times = value.map((dayOff: any) => {
        return moment(dayOff.period.from).format('DD MMM YYYY');
      });

      return (
        <SectionContainer onClick={onClick ? () => {
          onClick?.(reasonKey);
        }: undefined} color={dayOffColor}>
          <>
            <SectionHeader
              label="Date"
            />
            {
              times.map((time: any) => {
                return (
                  <TimeListSection
                    text={time}
                  />
                );
              })
            }
            <SectionBottomContainer
              labelLeft="Total days"
              labelRight="Reason"
              textLeft={`${times.length} day${times.length > 1 ? 's' : ''}`}
              textRight={reasonKey}
            />
          </>
        </SectionContainer>
      )
    });
  };

  return (
    <SectionWrapper>
      <>
        <SectionLabel
          Icon={DaysOffMenuIcon}
          label="Days off"
        />

        {
          daysOff?.length
            ? renderSections()
            : <SectionEmptyBlock />
        }
      </>
    </SectionWrapper>
  );
}
